import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    title: '',
};

class TabMenuTitle extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-tab-menu__title',
            className,
        ];
    }

}

TabMenuTitle.propTypes = propTypes;

TabMenuTitle.defaultProps = defaultProps;

export default TabMenuTitle;
